import * as React from 'react';
import { Slide as SlideProps } from './model';
import Media from '../Media';

const Slide = ({
  id,
  media,
  rolloverMedia,
  ctaUrl,
  width,
  height
}: SlideProps) => {
  // console.log('slideProps', media);
  return <Media {...media} width={width} height={height} />
};

export default Slide;
